module.exports = __webpack_public_path__ + "img/Frame18.9018498d.png";